import React from 'react';
import {isMobile} from 'react-device-detect';
const BundleItemTitles = (props) => {
  return (
    <div className='productAndServicesItemContainer_bundle_titles'>
      <div style={{width: `${props.bundleNameWidth}%`}} className={`d-flex ${isMobile ? 'pb-2' : ''}`}>
        <span className='blackShadeColor'>מוצר</span>
        <span className={`semiBold ${!isMobile && 'pr-2'}`}>{props.bundleName}</span>
      </div>
      <div style={{width: `${props.addressWidth}%`}} className='d-flex'>
        <span className='blackShadeColor'>כתובת התקנה</span>
        <span className={`semiBold ${!isMobile && 'pr-2'}`}>{props.address}</span>
      </div>
    </div>
  );
};
export default BundleItemTitles;
